import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import 'react-multi-carousel/lib/styles.css';

const Content = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);
  const [visibleCards, setVisibleCards] = useState([]);

  


  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await fetch('https://bkf.onrender.com/BKFannouncements');
        if (!response.ok) {
          throw new Error('Failed to fetch announcements');
        }
        const data = await response.json();
        // console.log('Fetched announcements:', data);
        setAnnouncements(data);
        setIsLoaded(true);
      } catch (err) {
        console.error('Error fetching announcements:', err);
        setError(err.message);
      }
    };

    fetchAnnouncements();
  }, []);

  useEffect(() => {
  if (isLoaded && announcements.length > 0) {
    announcements.slice()
      .sort((a, b) => new Date(b.date) - new Date(a.date))
      .forEach((_, index) => {
        setTimeout(() => {
          setVisibleCards((prev) => [...prev, index]);
        }, index * 150); // 150ms delay between each card
      });
  }
}, [isLoaded, announcements]);


  if (error) {
    return <p>Error loading announcements: {error}</p>;

   
  }
    const CF_BASE = "https://d2b3xd88n081z3.cloudfront.net";

return (
  <div style={{ width: '100%', minHeight: '350px', margin: '1.5%', padding: '1.5%', }}>
      <video
        autoPlay
    
    muted
    playsInline
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      zIndex: -1,
    }}
      >
        <source src={`${CF_BASE}/public/backgroundgrey2.mp4`} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    {isLoaded && announcements.length > 0 ? (
      <div
        className="announcements-list"
        style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '20px',
           
            maxWidth: '960px', // max 3 cards per row (3 * 300px + gaps)
            margin: '0 auto', // center container on page
              alignItems: 'stretch',
          }}
      >
        {announcements
          .slice() // create a copy so you don't mutate state
          .sort((a, b) => new Date(b.date) - new Date(a.date)) // most recent first
          .map((ann, index)  => (
         <div
          key={ann.id || ann.update}
          style={{
           
             opacity: visibleCards.includes(index) ? 1 : 0,
    transform: visibleCards.includes(index) ? 'translateY(0)' : 'translateY(20px)',
    transition: 'opacity 0.6s ease, transform 0.6s ease',
          }}
          className="announcement-card"
        >
          <Card
            className="card-body"
            style={{
              margin: '0',
              padding: '2.5%',
              cursor: 'pointer',
               height: '100%',          // 👈 key
              display: 'flex',         // 👈 key
              flexDirection: 'column',
              
            }}
          >
            <Link to={`/Announcements/${ann.Update}`} 
              style={{
    textDecoration: 'none',
    display: 'flex',
    flexDirection: 'column',
    height: '100%', // 👈 important
  }}
              >
              {/* <Card.Img variant="top" src={ann.media3} alt={ann.media3 || 'announcement'} /> */}
              <div 
              style={{
                marginTop: '4%',
              }}
              >
                <h4>{ann.Update}</h4>
                <h4>{ann.date}</h4>
                <p style={{ marginBottom: 0 }}>
  {ann.description}
</p>

              </div>
            </Link>
          </Card>
        </div>

          ))}
      </div>
    ) : (
       <div style={{ height:"100vh", marginTop: "50%", marginRight: "25%", marginLeft: "25%" }}>
            <Card className="card-body" 
            
             style={{
            overflow: 'hidden',
            boxSizing: 'border-box',
            marginTop: '50%',
            width: '100%',
            marginBottom: '50%',
            position: 'relative',
            color: 'silver',
            borderRadius: '10px'
          }}>
              <h1 style={{ textAlign: 'center' }}>Loading</h1>
            </Card>
          </div>
    )}
  </div>
);


};

export default Content;
